<template>
  <div>
    <Navigation />

    <!-- Start Contact Area -->
    <section class="contact-section ptb-100">
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <div class="contact-info-address">
              <h3>Quick Contact</h3>

              <div class="info-contact">
                <i class="flaticon-pin"></i>
                <h3>Location</h3>
                <span> P O Box 193ABF Block 8<br />Gaborone, Botswana </span>
              </div>

              <div class="info-contact">
                <i class="flaticon-call"></i>
                <h3>Call Us</h3>
                <span>
                  <a href="tel:+26774103043">+26774103043</a>
                </span>
              </div>

              <div class="info-contact">
                <i class="flaticon-email"></i>
                <h3>Email Us</h3>
                <span>
                  <a href="mailto:admin@clcentre.org">admin@clcentre.org</a>
                </span>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="contact-area">
              <div class="contact-content">
                <h3>Let’s talk!</h3>
                <p>Want to reach out to us? Fill this form</p>
              </div>

              <div class="contact-form">
                <iframe
                  src="https://docs.google.com/forms/d/e/1FAIpQLSf75Q_hVROoFbsg6U31IIxH8Xs0t1yTcg5-iS2R0yqlEt5FQw/viewform?embedded=true"
                  width="640"
                  height="812"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                  >Loading…</iframe
                >
                <!--<form id="contactForm">
                  <div class="row">
                    <div class="col-lg-6 col-md-6">
                      <div class="form-group">
                        <input
                          type="text"
                          name="name"
                          id="name"
                          class="form-control"
                          required
                          data-error="Please enter your name"
                          placeholder="Name"
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                      <div class="form-group">
                        <input
                          type="text"
                          name="phone_number"
                          id="phone_number"
                          required
                          data-error="Please enter your number"
                          class="form-control"
                          placeholder="Phone"
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                      <div class="form-group">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          class="form-control"
                          required
                          data-error="Please enter your email"
                          placeholder="email"
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                      <div class="form-group">
                        <input
                          type="text"
                          name="msg_website"
                          id="msg_website"
                          class="form-control"
                          required
                          data-error="Please enter your website"
                          placeholder="Website"
                        />
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <div class="form-group">
                        <textarea
                          name="message"
                          class="form-control"
                          id="message"
                          cols="30"
                          rows="6"
                          required
                          data-error="Write your message"
                          placeholder="Write Something"
                        ></textarea>
                        <div class="help-block with-errors"></div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="send-btn">
                        <button type="submit" class="default-btn">
                          Contact us
                          <i class="flaticon-right"></i>
                          <span></span>
                        </button>
                      </div>
                      <div id="msgSubmit" class="h3 text-center hidden"></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </form>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Contact Area -->
    <Footer />
  </div>
</template>

<script>
import Navigation from "./navBar/Navigation";
import Footer from "./Footer";

export default {
  name: "Contact",
  components: {
    Navigation,
    Footer
  }
};
</script>

<style scoped></style>